import React from 'react';
import CryptoJS from 'crypto-js';
import { isString, datejs, getCookie } from '@block/utils';
import { Form } from '@block/plug';
import { haiouUrlMap } from '@src/consts';
import doAction from './Ajax';

export { default as doAction } from './Ajax';

export * from './form';

// 判断是否是空串
export const isEmptyString = (value?: string) => value === null || value === undefined || value === '';

/**
 * Promise 模式的 React#setState
 * @param {object} newState 传给 React#setState 的参数
 * @returns {Promise|Promise<T>} 返回的 Promise 会在 setState 的 callback 被调用时完成
 */
export const setStateAsync = (that: DefaultAny, newState: DefaultAny) =>
  new Promise((resolve) => that.setState(newState, resolve));

// 获取tenantUid
export const tenantUid = () => {
  const { hash } = window.location;
  const arr = hash.split('/');
  return arr[2];
};

export const getPattern = (pattern) => {
  if (!pattern) {
    return null;
  }
  if (isString(pattern)) {
    return new RegExp(pattern);
  }
  return pattern;
};

// 获取服务类型 用来区分是入职背调还是入职候选人 将类型挂载到window上
export const getServiceType = async () => {
  const id = window.location.hash.split('/')[2];
  const data = await doAction(`/api/candidate/${id}/backgroundCheck/getBackgroundCheckType`, {}, null);
  const { backgroundCheckTypeValue, backgroundCheckTypeIndex, hasSign, signType } = data;
  window.checkTypeIndex = backgroundCheckTypeIndex; //  0 不需要背调  1 offer背调  2 offer前背调
  // window.checkTypeIndex = 0;
  window.checkTypeValue = backgroundCheckTypeValue;
  window.hasSign = hasSign; // 是否签署完电子签 false  未签署  true 已签署
  window.signType = signType; // 签署类型 0 无需签署 1电子签署 2手动签署
};

// 校验模块中的每一项 例如工作经历中的每段歇业经历  教育经历的每段教育经历
export const validateItems = (refs: React.RefObject<Form>[]) => {
  const statusList = [];
  refs.forEach((item) => {
    const { current } = item;
    if (current) {
      statusList.push(current.validateFields());
    }
  });
  return statusList.indexOf(false) === -1;
};

export const compareDate = (startDate: datejs.ConfigType, endDate: datejs.ConfigType) => {
  if (!endDate || !startDate) return true;
  return datejs(startDate).toDate().getTime() <= datejs(endDate).toDate().getTime();
};

export const getEnv = () => {
  const { origin } = window.location;

  if (origin.includes('ruzhi.meituan.com')) return 'prod';
  if (origin.includes('it.st')) return 'st';
  if (['localhost', 'it.test'].some((path) => origin.includes(path))) return 'test';
  return 'prod';
};

const env = getEnv();

const secret = 'A28eynlM';

// 加密
export const encrypt = (value: string) => {
  return CryptoJS.AES.encrypt(value, secret).toString();
};

// 解密
export const decrypt = (ciphertext: string) => {
  const res = CryptoJS.AES.decrypt(ciphertext, secret).toString(CryptoJS.enc.Utf8);
  return res;
};

export const getHaiouUrl = () => {
  const assetLid = encrypt(getCookie('asset_lid') || '');
  const { origin } = window.location;
  let url = haiouUrlMap[env] || '';
  if (env === 'test') {
    if (origin.includes('-sl-')) {
      url = url.replace('http://', origin.split('ruzhi')[0]);
    }
    // 本地获取海鸥地址加泳道
    // if (origin.includes('localhost')) {
    //   url = url.replace('http://', 'http://1941-lscfu-sl-');
    // }
  }
  return `${url}/v2/eam/ruzhi?asset_lid=${assetLid}`;
};
